import { render } from "./MatchList.vue?vue&type=template&id=67768ba7&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"

import "./MatchList.vue?vue&type=style&index=0&id=67768ba7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67768ba7"]])

export default __exports__